import axios from "axios";
import { baseUrl } from "../config/constants";
const { post, get } = axios;

export const serviceCall = {
  signUp,
};

async function signUp(url, data) {
  try {
    const response = await post(`${baseUrl}${url}`, data);
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
}

